import { useEffect, useMemo } from 'react';
import Raven from 'raven-js';
import { useIsRetail } from '../../../hooks/useIsRetail';
import { useRepInfo } from '../../../hooks/useRepInfo';
import { AssignableModal } from './AssignableModal';
import { UnassignableModal } from './UnassignableModal';
import { trackPurchaseMotionFailure } from '../../../utils/metrics';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { getRepName } from '../../../utils/pql';
import { trackPotentialBannerInteraction } from '../../../utils/ums';
import { isRpcError } from '../../../utils/error';
import { jsx as _jsx } from "react/jsx-runtime";
const checkIsAssignable = ({
  isAssignable,
  isRetail,
  repInfo
}) => !!(isAssignable && !isRetail && repInfo !== null && repInfo !== void 0 && repInfo.link);
const CommModalContainer = ({
  apiName,
  trackingData,
  upgradeConfig,
  level,
  isAssignable,
  onClose
}) => {
  const {
    error: repInfoError,
    loading: repInfoLoading,
    repInfo
  } = useRepInfo();
  const {
    error: isRetailError,
    loading: isRetailLoading,
    isRetail
  } = useIsRetail();
  const trackingProperties = useMemo(() => getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig,
    sourceKey: 'TALK_TO_SALES'
  }), [apiName, trackingData, upgradeConfig]);
  const handleClose = () => {
    track('communication-methods', Object.assign({
      action: 'closed'
    }, trackingProperties, {
      repName: getRepName(repInfo)
    }));
    onClose();
  };
  useEffect(() => {
    if (!isRetailLoading && !repInfoLoading) {
      if (isRetailError || repInfoError) {
        trackPurchaseMotionFailure({
          uniqueId: trackingData.uniqueId,
          apiName,
          purchaseMotion: 'TALK_TO_SALES'
        });
      } else {
        const isAssignableClick = checkIsAssignable({
          isAssignable,
          isRetail: isRetail !== null && isRetail !== void 0 ? isRetail : false,
          repInfo
        });
        track('contact-sales-button', Object.assign({
          action: isAssignableClick ? 'clicked' : 'clicked talk to ISC'
        }, trackingProperties, {
          isAssignable: isAssignableClick,
          repName: getRepName(repInfo)
        }));
        if (upgradeConfig) {
          track('interaction', Object.assign({
            action: 'clicked upgrade point',
            isAssignable: isAssignableClick
          }, trackingProperties));
          track('interaction', Object.assign({
            action: 'clicked talk to sales',
            isAssignable: isAssignableClick,
            isPrimaryCta: level === 0,
            isSecondaryCta: level === 1
          }, trackingProperties));
          trackPotentialBannerInteraction(upgradeConfig).catch(e => {
            if (!isRpcError(e) || e.cause.status !== 0) {
              Raven.captureException(e, {
                fingerprint: ['Failed to submit interaction from CommModalContainer'],
                extra: {
                  upgradeConfig
                }
              });
            }
          });
        }
      }
    }
  }, [apiName, isAssignable, isRetail, isRetailError, isRetailLoading, level, repInfo, repInfoError, repInfoLoading, trackingData, trackingProperties, upgradeConfig]);
  if (repInfoLoading || isRetailLoading) return null;
  if (!isRetailError && !repInfoError && repInfo && checkIsAssignable({
    isAssignable,
    isRetail,
    repInfo
  })) {
    return /*#__PURE__*/_jsx(AssignableModal, {
      apiName: apiName,
      repInfo: repInfo,
      trackingData: trackingData,
      upgradeConfig: upgradeConfig,
      onClose: handleClose
    });
  }
  return /*#__PURE__*/_jsx(UnassignableModal, {
    apiName: apiName,
    isRetail: isRetail !== null && isRetail !== void 0 ? isRetail : false,
    trackingData: trackingData,
    upgradeConfig: upgradeConfig,
    onClose: handleClose
  });
};
export default CommModalContainer;